// src/components/Footer.js
import React from 'react';
import './Footer.css';
import { FaFacebookF, FaInstagram, FaYoutube, FaSoundcloud } from 'react-icons/fa';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="social-icons">
        <a href="https://www.facebook.com/lumoensemble" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
        <a href="https://www.instagram.com/lumoensemble" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
        <a href="https://www.youtube.com/@lumoensemble7988" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
        <a href="https://soundcloud.com/lumo-ensemble" target="_blank" rel="noopener noreferrer"><FaSoundcloud /></a>
      </div>

      <div className="contact-info">
        <p className="contact-title">Kiinnostuitko? Ota meihin yhteyttä</p>
        <p>
          <a href="mailto:lumoensemble@gmail.com">lumoensemble@gmail.com</a>
        </p>
        <p>
          <a href="tel:+358403580099">+358 40 3580099</a>
        </p>
      </div>

      <div className="footer-text"><p >© {new Date().getFullYear()} Lumo Ensemble</p></div>
    </footer>
  );
}
